import { styled } from "@mui/material";

export const CtaWrapper = styled("div")(({ theme }) => ({
    display: "flex",
    justifyContent: "space-between",
  
    "@media (max-width: 600px)": {
      marginBottom: theme.space._500,
      padding: `0 ${theme.space._400} 0 0`,
    }
}));